export const environment = {
    production: true,
    host: 'https://ideabox.name',
};
